import { NodeType, Edge } from '@weave/schema-gen-ts/dist/schemas/phone/callroute/v1/callroute_service.pb';
import { useQueryClient } from 'react-query';
import { CallRouteV1 } from '@frontend/api-call-route';

interface CallQueueExpansionData {
  deviceNames?: string[];
  deviceCount?: number;
  callQueueName?: string;
  greetingMediaFileName?: string;
  greetingMediaItemId?: string;
}

type CachedCallRouteData = {
  nodes?: CallRouteV1.Types.Node[];
  callRouteId?: string;
  edges?: Edge[];
  callRoute?: any;
};

export const useCallQueueCacheUpdater = (callQueueId: string) => {
  const queryClient = useQueryClient();

  const updateCallRouteCaches = (expansionData: CallQueueExpansionData) => {
    queryClient.setQueriesData(
      {
        queryKey: ['call-route-v1', 'Read'],
        exact: false,
      },
      (oldCallRoute: CachedCallRouteData | undefined) => {
        if (!oldCallRoute?.nodes) {
          return oldCallRoute || {};
        }

        // Update only nodes in the nodes array that are call queues with matching ID
        const updatedNodes = oldCallRoute.nodes.map((node) => {
          if (
            node.type === NodeType.NODE_TYPE_CALL_QUEUE &&
            node.callObject?.primitiveId === callQueueId &&
            node.callObject?.callQueueExpansion
          ) {
            return {
              ...node,
              callObject: {
                ...node.callObject,
                ...(expansionData.callQueueName && { primitiveName: expansionData.callQueueName }),
                callQueueExpansion: {
                  ...node.callObject.callQueueExpansion,
                  ...(expansionData.deviceCount !== undefined && { deviceCount: expansionData.deviceCount }),
                  ...(expansionData.deviceNames !== undefined && { deviceNames: expansionData.deviceNames }),
                  ...(expansionData.greetingMediaItemId !== undefined && {
                    greetingMediaItemId: expansionData.greetingMediaItemId,
                  }),
                  ...(expansionData.greetingMediaFileName !== undefined && {
                    greetingMediaFileName: expansionData.greetingMediaFileName,
                  }),
                },
              },
            };
          }
          return node;
        });

        return {
          ...oldCallRoute,
          nodes: updatedNodes,
        };
      }
    );
  };

  return {
    updateCallRouteCaches,
  };
};
